const payments = {
  free_plan: 'Free plan',
  starter_plan: 'Solo plan',
  pro_plan: 'Team plan',
  super_admin: 'Super Admin',
  simulations_used: '{{count}}/{{max}} simulations used',
  appraisals_used: '{{count}}/{{max}} appraisals used',
  unlimited_simulations: 'Unlimited simulations',
  unlimited_appraisals: 'Unlimited appraisals',
  invoices: 'Your invoices',
  invoices_description: 'View the invoices for this account.',
  no_invoices: "You don't have any invoices.",
  options: 'Your plan options',
  options_description:
    'View your plan information and switch plans according to you needs.',
  you_are_subscribed_pro: 'You are subscribed to the Team Plan.',
  you_are_subscribed_regular: 'You are subscribed to the Solo Plan.',
  you_are_subscribed_enterprise: 'You are subscribed to the Enterprise Plan.',
  keep_plan: 'Current plan',
  downgrade: 'Downgrade',
  downgrade_confirmation: {
    title: 'Downgrade your plan',
    text: 'Do you really want to downgrade to the Free plan?',
  },
  upgrade: 'Upgrade',
  contact_us: 'contact@appvelocity.io',
  current_plan: 'Current plan',
  per_month: 'Per month',
  plan_ends_on:
    'Your plan period ends on {{date}} and will be automatically renewed.',
  plan_ends_on_no_auto:
    'Your plan period ends on {{date}} and will not be automatically renewed.',
  plans: {
    free: {
      title: 'Free',
      price: 'Free',
      description: {
        a: '5 simulations',
        b: 'Up to 30 steps per challenge',
        c: '5 reviews',
        d: '50 human responses',
      },
    },
    starter: {
      title: 'Solo',
      title_with_price: 'Velocity Solo plan ({{price}}/month)',
      description: {
        a: '50 simulations',
        b: 'Up to 50 steps per challenge',
        c: 'Passwords',
        d: 'Unlimited reviews',
        e: 'Unlimited heat maps',
        f: 'Unlimited human responses',
      },
    },
    pro: {
      title: 'Team',
      title_with_price: 'Velocity Team plan ({{price}}/month)',
      description: {
        a: '200 simulations',
        b: 'Up to 50 steps per challenge',
        c: 'All solo +',
        d: 'Unlimited seats',
        e: 'Shared simulation pool',
        f: 'Centralised billing & admin',
        g: 'Usage analytics',
      },
    },
    enterprise: {
      title: 'Enterprise',
      title_with_price: 'Custom',
      description: {
        a: 'Custom contracts are based on minimum consumption levels of simulations.',
        b: 'SSO',
        c: 'SOC2, ISO27001',
        d: 'Volume discounts',
        e: 'Invoice / PO billing',
        f: 'Custom legal terms',
        g: 'Training',
        h: 'SLAs',
        i: '24/7 priority support',
      },
      contact_sales: 'contact@appvelocity.io',
      info: 'This team is on the Enterprise plan. Please contact sales in case of any questions or needs.',
    },
  },
  status: {
    success: {
      title: 'Payment Success',
      text: 'You have successfully subscribed to Velocity.',
      go_back_solo: 'Go to Report dashboard',
      set_up_team: 'Lets set up your Team',
    },
    fail: {
      title: 'Payment Failed',
      text: 'We had some problems completing your payment.',
    },
    can_close: 'You can close this page.',
  },
  upgrade_now: 'Upgrade now for {{price}}',
  free_plan_description_1: 'The free plan now works on demo files only.',
  free_plan_description_2:
    'To run simulations on your own designs,\nupgrade your plan.',
  free_plan_or: 'or',
  use_demos_for_free: 'Use our demos for free',
  free_plan_update: 'Free plan update',
  confirm_your_subscription: 'Confirm your subscription',
  about_to_purchase: "You're about to purchase the <tag>{{plan}}</tag>.",
  subscription_will_be_linked:
    'The subscription will be linked to <tag>{{email}}</tag>.',
  not_you: 'Not you? Sign out',
  continue_to_secure_checkout: 'Continue to secure checkout',
} as const;

export default payments;
